<!--
 * @Description: 新增，编辑，详情，完成访客计划
 * @Author: cxh
 * @Date: 2022-06-13 16:21:49
 * @LastEditTime: 2023-07-04 16:09:02
 * @LastEditors: cxh
-->
<template>
  <a-form name="detailsForm" ref="baseFormRef" :model="form">
    <dc-layout-card title="跟进记录">
      <dc-form-item label="客户名称" name="followRefId" :rules="[{ required: true, message: '请选择' }]">
        <ClueAndCustomerSelect
          appId="cos_lbu"
          v-model:value="form.followRefId"
          v-model:label="form.customerName"
          v-model:record="customerRecord"
          :disabled="route.query.followRefId || route.query.planId ? true : false"
          @change="changeCus"
          :view="view"
        />
      </dc-form-item>
      <template v-if="view">
        <dc-form-item label="客户ID">
          <CosInput v-model:value="form.followRefId" placeholder="请输入" :view="view" />
        </dc-form-item>
        <dc-form-item label="客户阶段">
          <CosSelect
            v-model:value="form.stage"
            :options="clueAndcustomerPhaseEnum"
            allowClear
            placeholder="请选择"
            :disabled="true"
            :view="view"
          />
        </dc-form-item>
      </template>
      <dc-form-item
        label="跟进方式"
        name="mode"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]"
      >
        <ParamCodesSelect
          :options="paramCodeData.lbu_follow_mode"
          v-model:value="form.mode"
          v-model:label="form.lbuFollowTxt"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="跟进时间" name="startTime" :rules="[{ required: true, message: '请选择' }]">
        <CosDateTimeRagePicker
          v-model:startTime="form.startTime"
          v-model:endTime="form.endTime"
          :minuteStep="15"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="跟进状态"
        name="followStatus"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]"
      >
        <CosSelect
          :value="form.followStatus"
          :options="customerAllStatusEnum"
          allowClear
          placeholder="请选择"
          :disabled="true"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        name="contactId"
        label="联系人"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]"
      >
        <CosSelect
          v-model:value="form.contactId"
          :fieldNames="{
            label: 'name',
            value: 'id'
          }"
          allowClear
          placeholder="请选择"
          @change="changeContactId"
          :options="followUpOptions.contactList"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="关联商机" name="chanceId" :rules="[{ required: [1024, 1020, 1022].includes(form.lbuVisitPurpose) && followUpOptions.saleChanceList.length > 0, message: '请选择' }]">
        <BusinessName appId="cos_lbu" v-model:value="form.chanceName" v-if="view" />
        <CosSelect
          v-model:value="form.chanceId"
          allowClear
          placeholder="请选择"
          v-else
          :disabled="disabled || route.query.chanceId ? true : false"
          :view="view"
          filterNoVal
        >
          <a-select-option v-for="item in saleChanceData" :key="item.chanceId" :disabled="item.disabled">
            <BusinessName appId="cos_lbu" v-model:value="item.saleChanceName" />
          </a-select-option>
        </CosSelect>
      </dc-form-item>
      <dc-form-item label="完成访客计划" name="planId">
        <CosSelect
          v-model:value="form.planId"
          :fieldNames="{
            label: 'title',
            value: 'id'
          }"
          allowClear
          placeholder="请选择"
          :options="visitPlanData"
          :disabled="disabled || route.query.planId ? true : false"
          :view="view"
          @change="changePlan"
          filterNoVal
        />
      </dc-form-item>
      <dc-form-item label="拜访目的" name="lbuVisitPurpose" :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择拜访目的' }]">
        <ParamCodesSelect
          v-model:value="form.lbuVisitPurpose"
          :options="paramCodeData.lbu_follow_purpose"
          :disabled="disabled"
          :view="view"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="拜访签到记录" name="signInId">
        <CosSelect
          show-search
          v-model:value="form.signInId"
          :view="view"
          :viewOptions="signInListOptions"
          :viewFieldNames="{ label: 'signInTime', value: 'id' }"
        >
          <a-select-option v-for="item in signInListOptions" :key="item.id" :value="item.id">
            <p :title="item.signInTime">{{ item.signInTime }}</p>
            <p :title="item.customerAddress" style="color: #999">{{ item.customerAddress }}</p>
          </a-select-option>
          <template #view="{ option }">
            <a-tooltip placement="topLeft" color="rgba(19, 32, 67, 0.9)" v-if="option && option.customerAddress">
              <template #title>
                <p>{{ option.customerAddress }}</p>
              </template>
              <div>
                {{ option.signInTime || option.id }}
                <environment-outlined />
              </div>
            </a-tooltip>
            <p v-else>{{ option.signInTime || option.id || '--' }}</p>
          </template>
        </CosSelect>
      </dc-form-item>
      <dc-form-item label="陪访人">
        <CosInput v-model:value="form.lbuAccompanyPerson" placeholder="请输入" :view="view" />
      </dc-form-item>
      <template v-if="view">
        <dc-form-item label="跟进人">
          <CosInput v-model:value="form.dutyByName" placeholder="请输入" :view="view" />
        </dc-form-item>
        <dc-form-item label="创建人">
          <CosInput v-model:value="form.createByName" placeholder="请输入" :view="view" />
        </dc-form-item>
        <dc-form-item label="创建时间">
          <CosInput v-model:value="form.createTime" placeholder="请输入" :view="view" />
        </dc-form-item>
        <dc-form-item label="更新人">
          <CosInput v-model:value="form.updateByName" placeholder="请输入" :view="view" />
        </dc-form-item>
        <dc-form-item label="更新时间">
          <CosInput v-model:value="form.updateTime" placeholder="请输入" :view="view" />
        </dc-form-item>
      </template>
      <a-col :span="24"></a-col>
      <dc-form-item label="目的" name="lbuPurpose" :rules="[{ required: true, message: '请输入' }]" :span="12">
        <CosTextarea v-model:value="form.lbuPurpose" :maxlength="2000" placeholder="请输入" :view="view" />
      </dc-form-item>
      <dc-form-item label="跟进过程" name="process" :rules="[{ required: true, message: '请输入' }]" :span="12">
        <CosTextarea v-model:value="form.process" :maxlength="2000" placeholder="请输入" :view="view" />
      </dc-form-item>
      <dc-form-item label="当前遇到的问题" name="problem" :rules="[{ required: true, message: '请输入' }]" :span="12">
        <CosTextarea v-model:value="form.problem" :maxlength="2000" placeholder="请输入" :view="view" />
      </dc-form-item>
      <dc-form-item label="后续" name="result" :rules="[{ required: true, message: '请输入' }]" :span="12">
        <CosTextarea v-model:value="form.result" :maxlength="2000" placeholder="请输入" :view="view" />
      </dc-form-item>
      <dc-form-item label="上传附件" name="fileId" :span="24">
        <UploadFile :view="view" v-model:value="form.fileId" valueType="array" />
      </dc-form-item>
    </dc-layout-card>
    <!---只有新增才显示访客计划、销售商机----->
    <template
      v-if="route.path.includes('/lbu/followUpRecord/add') || route.path.includes('/lbu/followUpRecord/visitingPlan')"
    >
      <div class="dc-card-header">
        <div class="dc-card-header-defaut">
          <div class="dc-card-header-defaut-line"></div>
          <p>访客计划</p>
          <div class="dc-card-header-defaut-subtitle">
            <a-button type="primary" @click="addVisitPlan" ghost>新增</a-button>
          </div>
        </div>
      </div>
      <div class="page-card" v-for="(item, index) in form.visitPlanList" :key="index">
        <p v-if="index === 0" style="border-bottom: 1px dashed rgb(211, 218, 224); margin-bottom: 12px"></p>
        <div class="dc-card-header">
          <div class="dc-card-header-defaut">
            <div class="dc-card-header-defaut-line"></div>
            <p>{{ `访客计划${index + 1}` }}</p>
            <div class="dc-card-header-defaut-subtitle">
              <a-button danger @click="deleteVisitPlan(index)">删除</a-button>
            </div>
          </div>
        </div>
        <VisitorProgramForm
          :ref="(el) => setVisitorRef(`visitor${index}`, el)"
          :saleChanceRefId="form.followRefId || '--'"
          v-model:value="form.visitPlanList[index]"
        />
      </div>
      <div class="paddingLine"></div>
      <div class="dc-card-header">
        <div class="dc-card-header-defaut">
          <div class="dc-card-header-defaut-line"></div>
          <p>商机</p>
          <div class="dc-card-header-defaut-subtitle">
            <a-button danger @click="hasSaleChance = false" v-if="hasSaleChance">取消</a-button>
            <a-button type="primary" @click="addSaleChance" ghost v-else>新增</a-button>
          </div>
        </div>
      </div>
      <BusinessForm
        ref="saleChanceFormRef"
        type="add"
        v-if="hasSaleChance"
        v-model:value="form.saleChance"
        :saleChanceRefId="true"
      />
    </template>
  </a-form>
  <cos-footer-button
    v-if="!disabled"
    v-model:value="form"
    :formRef="baseFormRef"
    :resetValue="resetValue"
    :loading="loading"
    :workCode="form.dutyBy"
    @validate="validate"
    @reset="handleReset"
    :permissionPage="permissionPage"
    :disabled="false"
  >
    <a-button @click="handleAddConcat">新增联系人</a-button>
    <a-button type="primary" @click="handleSubmit" :loading="loading" v-permission="permissionPage.save">保存</a-button>
  </cos-footer-button>
  <!--新增联系人--->
  <ConcatModal ref="concatModalRef" @success="successConcat" :contactRefId="form.followRefId" appId="cos_lbu"/>
</template>

<script setup lang="ts">
import { signInRecordListByCosId, listByParamCodes } from '@/api/common'
import { ref, reactive, computed, onMounted, watch, PropType } from 'vue'
import { useRoute } from 'vue-router'
import UploadFile from '@/components/UploadFile'
import { EnvironmentOutlined } from '@ant-design/icons-vue'
import VisitorProgramForm from '../../components/VisitorProgramForm.vue'
import { clueAndcustomerPhaseEnum, customerAllStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { followRecordsAddByMess, followRecordsAddOrUpdate, followRecordsDetail } from '@/api/yuntuSales/followUpManage'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import ConcatModal from '@/components/TabsContacts/lbu/editModal.vue'
import type { LbuFollowUpRecordEdit } from '@/typings/api/followUpManage'
import { DcMessage } from '@dc-platform/dc-components'
import BusinessName from '@/components/BusinessName/index.vue'
import BusinessForm from '@/views/yuntuSales/chanceManage/business/components/BusinessForm.vue'
import CosDateTimeRagePicker from '@/components/CosDateTimeRagePicker/index.vue'
import { cloneDeep } from 'lodash-es'
import { goBack } from '@/hooks/cosRouter'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter } from '@/utils/index'
import dayjs from 'dayjs'
const route = useRoute()
const props = defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object as PropType<LbuFollowUpRecordEdit>
  },
  view: {
    type: Boolean
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
const concatModalRef = ref()

const initCos = ref(true)
const paramCodeData = ref<{
  lbu_follow_mode: []
  lbu_follow_purpose: []
}>({
  lbu_follow_mode: [], // 拜访方式
  lbu_follow_purpose: [] // 访客目的
})
const customerRecord = ref<any>({})
const followUpOptions = reactive<{
  contactList: any[]
  saleChanceList: any[]
  visitPlanList: any[]
}>({
  contactList: [],
  saleChanceList: [],
  visitPlanList: []
})
const baseFormRef = ref()
const saleChanceFormRef = ref()
const hasSaleChance = ref(false)
const visitorProgramFormRef = reactive<any>({})
const form = ref<LbuFollowUpRecordEdit>({
  saleChance: {},
  visitPlanList: []
})
const resetValue = ref<LbuFollowUpRecordEdit>({
  saleChance: {},
  visitPlanList: []
})
const addConcatId = ref('')
const loading = ref(false)
const signInListOptions = ref([])
const getSignInList = async () => {
  try {
    const res: any =
      form.value.followRefId &&
      (await signInRecordListByCosId({ cosId: form.value.followRefId, signInId: form.value.signInId }))
    signInListOptions.value = res.data
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}
const emit = defineEmits(['update:detail', 'getDetail'])
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      form.value = v
      resetValue.value = cloneDeep(v)
    }
  },
  { immediate: true }
)
// 处理访客计划数据(只处理详情)
const visitPlanData = computed(() => {
  const { planId, planTitle } = form.value
  const { visitPlanList } = followUpOptions
  if (planId && planTitle && route.query.id) {
    const obj = visitPlanList.find((item: any) => item.id === planId)
    if (!obj) {
      visitPlanList.unshift({
        id: planId,
        title: planTitle,
        disabled: true
      })
    }
  }
  return visitPlanList
})
// 处理商机数据(只处理详情)
const saleChanceData = computed(() => {
  const { chanceId, chanceName } = form.value
  const { saleChanceList } = followUpOptions
  if (chanceId && chanceName && (route.query.id || route.query.planId)) {
    const obj = saleChanceList.find((item: any) => item.chanceId === chanceId)
    if (!obj) {
      saleChanceList.unshift({
        chanceId: chanceId,
        saleChanceName: chanceName,
        disabled: true
      })
    }
  }
  return saleChanceList
})
// 获取详情
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    followRecordsDetail(route.query.id)
      .then((res) => {
        form.value = res.data ? res.data : {}
        // emit('update:detail', res.data)
        emit('getDetail', res.data)
        resetValue.value = cloneDeep(res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 设置访客计划的ref
const setVisitorRef = (name: string, el: any) => {
  if (el) {
    visitorProgramFormRef[name] = el
  } else {
    delete visitorProgramFormRef[name]
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_follow_mode', 'lbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = {
          ...res.data
        }
      } else {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
        paramCodeData.value = {
          ...res.data
        }
      }
    }
  })
}
// 新增客户联系人
const handleAddConcat = () => {
  if (!form.value.followRefId) {
    DcMessage.error('请先选择客户')
    return
  }
  concatModalRef.value.toggle()
}
// 联系人新增成功回调
const successConcat = (type: any, res: any) => {
  if (res.data) {
    addConcatId.value = res.data
  } else {
    addConcatId.value = ''
  }
  getMessage(form.value.followRefId, 'concat')
}
// 获取客户相关信息（访客计划，联系人，商机） type=concat：只获取联系人信息
const getMessage = (v: any, type: 'all' | 'concat' = 'all') => {
  followRecordsAddByMess({
    followRefId: v,
    planId: form.value.planId
  }).then((res) => {
    const { contactList, saleChanceList, visitPlanList } = res.data
    followUpOptions.contactList = contactList && contactList.length ? contactList : []
    if (type === 'concat') {
      // 填充默认值(新增的这条数据)
      const { contactId } = form.value
      if ((!contactId || contactId === -9) && contactList.length) {
        const c = contactList.find((v: any) => v.id === addConcatId.value)
        form.value.contactId = c?.id
        baseFormRef.value.clearValidate('contactId')
      }
    } else {
      followUpOptions.saleChanceList = saleChanceList && saleChanceList.length ? saleChanceList : []
      followUpOptions.visitPlanList = visitPlanList && visitPlanList.length ? visitPlanList : []
    }
  })
  if (type === 'all') {
    getSignInList()
  }
}

// 获取跟进相关信息
const changeCus = (v: any, option: any, init = false) => {
  initCos.value = false
  const { visitPlanList } = form.value
  visitPlanList?.forEach((item) => {
    item.visitRefId = v
    item.chanceId = undefined
  })
  form.value = {
    ...form.value,
    followRefId: v,
    saleChance: {
      ...form.value.saleChance,
      saleChanceRefId: v
    },
    visitPlanList,
    followStatus: option?.status,
    contactId: undefined,
    contactName: undefined,
    planId: undefined,
    chanceId: undefined
  }
}

// 获取跟进相关信息
const changePlan = (value: any) => {
  form.value.lbuVisitPurpose = value ? visitPlanData.value.find((e) => e.id === value)?.purpose : undefined
}
// 回显数据监听客户名称变化
watch(
  () => form.value.followRefId,
  (val) => {
    if (val) {
      getMessage(val)
    }
  },
  { immediate: true }
)
watch(
  () => customerRecord.value,
  (val) => {
    if (!initCos.value || !route.query.id) {
      form.value.followStatus = val?.status
      resetValue.value = cloneDeep(form.value)
    }
  },
  { immediate: true }
)
const changeContactId = (v: any, option: any) => {
  form.value.contactName = option ? option.name : undefined
}
// 提交表单
const handleSubmit = () => {
  const baseFormRefVali = baseFormRef.value?.validate()
  const saleChanceFormRefVali = saleChanceFormRef.value?.validate()
  const visitorProgramFormRefVali: any = []
  Object.values(visitorProgramFormRef).forEach((v: any) => {
    if (v) {
      visitorProgramFormRefVali.push(
        v
          .validate()
          .then((res: any) => res)
          .catch((res: any) => {
            if (!res.errorFields || !res.errorFields.length) {
              return res
            }
            return Promise.reject(new Error(res))
          })
      )
    }
  })
  Promise.all([baseFormRefVali, saleChanceFormRefVali, ...visitorProgramFormRefVali]).then(async (res) => {
    const p = {
      ...form.value,
      saleChance: hasSaleChance.value ? form.value.saleChance : undefined,
      visitPlanList: form.value.visitPlanList && form.value.visitPlanList.length ? form.value.visitPlanList : undefined
    }
    loading.value = true
    try {
      await followRecordsAddOrUpdate(p)
      if (route.query.planId) {
        DcMessage.success('已完成拜访')
      } else if (route.query.id) {
        DcMessage.success('编辑成功')
      } else {
        DcMessage.success('新增成功')
      }
      goBack()
    } catch (error) {}
    loading.value = false
  })
}
// 重置表单
const handleReset = () => {
  form.value.visitPlanList = []
  hasSaleChance.value = false
  form.value.saleChance = {}
}
// 校验访客计划表单
const validate = () => {
  Object.values(visitorProgramFormRef).forEach((v: any) => {
    if (v) {
      v.validate()
    }
  })
  saleChanceFormRef.value?.validate()
}
// 点击新增访客计划
const addVisitPlan = () => {
  if (!form.value.visitPlanList) {
    form.value.visitPlanList = []
  }
  form.value.visitPlanList.push({
    visitRefId: form.value.followRefId
  })
}
// 删除访客计划
const deleteVisitPlan = (index: number) => {
  form.value.visitPlanList?.splice(index, 1)
}
// 点击新增销售商机
const addSaleChance = () => {
  hasSaleChance.value = true
  form.value.saleChance = {
    saleChanceRefId: form.value.followRefId
  }
}
onMounted(() => {
  if (route.query.followRefId) {
    form.value = {
      followRefId: route.query.followRefId as string,
      chanceId: route.query.chanceId as string,
      saleChance: {
        saleChanceRefId: route.query.followRefId
      }
    }
    resetValue.value = cloneDeep(form.value)
  }
  if (form.value.startTime === undefined) {
    form.value.startTime = dayjs().format('YYYY/MM/DD HH:mm:ss')
    form.value.endTime = form.value.startTime
  }
  fetch()
  getByParamCodes()
})
</script>
<script lang="ts">
export default { name: 'BaseMessage' }
</script>
<style scoped>
.paddingLine {
  height: 12px;
  margin-left: -20px;
  margin-right: -20px;
  bottom: 0;
  background: #f9f9ff;
  margin-bottom: 16px;
}
.card-visitor-program-btn {
  margin-top: -12px;
  margin-bottom: 25px;
  text-align: right;
  border-bottom: 1px dashed #d3dae0;
}

.card-visitor-program-btn .ant-btn-background-ghost.ant-btn-primary {
  border-color: #d8dfe4;
}
</style>
